import { z } from 'zod';

export const ObserverRelationshipZod = z.union([
    z.literal('FinancialAdvisor'),
    z.literal('Attorney'),
    z.literal('InsuranceAgent'),
    z.literal('Friend'),
]);

export type ObserverRelationship = z.infer<typeof ObserverRelationshipZod>;
